"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _classnames = _interopRequireDefault(require("classnames"));

var _query = require("@reduxjs/toolkit/query");

var _services = require("@alycecom/services");

var _providers = require("../../providers");

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var palette = _ref.palette,
      spacing = _ref.spacing,
      zIndex = _ref.zIndex;
  return {
    stepContainer: {
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start',
      maxWidth: '100%',
      background: palette.background.darken,
      overflow: 'hidden',
      height: '100%'
    },
    stepContainerScrollable: {
      height: 'auto',
      overflow: 'auto'
    },
    scrollableArea: {
      height: '100%',
      zIndex: zIndex.drawer
    },
    stepContent: {
      padding: spacing(0, 2),
      margin: spacing(0, 'auto'),
      maxWidth: 1440,
      height: '100%',
      display: 'flex',
      flexDirection: 'column'
    },
    loader: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100%'
    }
  };
});

var StepperContainer = function StepperContainer(_ref2) {
  var children = _ref2.children,
      _ref2$scrollable = _ref2.scrollable,
      scrollable = _ref2$scrollable === void 0 ? true : _ref2$scrollable;
  var classes = useStyles();

  var _useGiftingFlowContex = (0, _providers.useGiftingFlowContext)(),
      batchId = _useGiftingFlowContex.batchId;

  var _useGetProspectingBat = (0, _services.useGetProspectingBatchByIdQuery)(batchId ? {
    batchId
  } : _query.skipToken),
      isFulfilled = _useGetProspectingBat.isSuccess;

  var isLoaderVisible = !!batchId && !isFulfilled;
  return /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: (0, _classnames.default)(classes.stepContainer, {
      [classes.stepContainerScrollable]: scrollable
    })
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: classes.scrollableArea
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: classes.stepContent
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    flex: "1 1 auto",
    height: "100%"
  }, isLoaderVisible ? /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: classes.loader
  }, /*#__PURE__*/_react.default.createElement(_material.CircularProgress, null)) : children))));
};

var _default = StepperContainer;
exports.default = _default;